/**
 * Chosen color ramps — hand-tuned OKLCH.
 *
 * Full rationale lives in src/index.css (“Color system” comment) and /dev/palette.
 * This file only lists the shared chroma *targets* and family hues so the gallery
 * page can document them without re-deriving values.
 *
 * Actual tokens are CSS variables; step colors may clamp below these targets
 * when a hue cannot hold the C in sRGB at that lightness.
 */

export const CHROMA_TARGETS: { step: string; C: number }[] = [
    { step: "25", C: 0.01 },
    { step: "50", C: 0.02 },
    { step: "100", C: 0.045 },
    { step: "200", C: 0.08 },
    { step: "300", C: 0.115 },
    { step: "400", C: 0.15 },
    { step: "500", C: 0.17 },
    { step: "600", C: 0.17 },
    { step: "700", C: 0.14 },
    { step: "800", C: 0.12 },
    { step: "900", C: 0.1 },
    { step: "950", C: 0.07 },
];

/** Shared lightness ladder (%). 500/600/700 anchored ≈ 3:1 / 4.5:1 / 7:1 for green on white. */
export const LIGHTNESS_TARGETS: { step: string; L: number }[] = [
    { step: "25", L: 98.75 },
    { step: "50", L: 97.5 },
    { step: "100", L: 94.5 },
    { step: "200", L: 89.0 },
    { step: "300", L: 82.0 },
    { step: "400", L: 74.0 },
    { step: "500", L: 65.1 },
    { step: "600", L: 55.2 },
    { step: "700", L: 45.1 },
    { step: "800", L: 39.0 },
    { step: "900", L: 33.0 },
    { step: "950", L: 25.0 },
];

export const STEPS = [
    "25", "50", "100", "200", "300", "400", "500", "600", "700", "800", "900", "950",
] as const;

export type RampName =
    | "success"
    | "warning"
    | "orange"
    | "destructive"
    | "cyan"
    | "blue"
    | "purple";

export const RAMPS: {
    name: RampName;
    hue: number;
    role: string;
}[] = [
    {
        name: "cyan",
        hue: 207.1,
        role: "Soft UI + Mix chrome — header cyan-200, CTA cyan-300, --primary cyan-500",
    },
    { name: "success", hue: 156, role: "Feedback — saved / positive" },
    { name: "warning", hue: 86, role: "Feedback — caution" },
    { name: "orange", hue: 55, role: "Warm accent — sparse use, not feedback" },
    { name: "destructive", hue: 20, role: "Feedback — error / danger" },
    { name: "blue", hue: 250, role: "True-blue accent — sparse use, not brand" },
    { name: "purple", hue: 302, role: "Accent — badges and minor highlights" },
];
